// removed by extract-text-webpack-plugin
module.exports = {"form-post-demand":"form-post-demand","form-post-demand-title":"form-post-demand-title","section":"section","form-post-demand-btn-wrap":"form-post-demand-btn-wrap","post-demand-btn":"post-demand-btn"};


//////////////////
// WEBPACK FOOTER
// ./components/users/sub-view/post-demand/style.scss
// module id = ./components/users/sub-view/post-demand/style.scss
// module chunks = 0